export enum OrganisationFormName {
  IsSubscriptionChannel = 'isSubscriptionChannel',
  ResidentialLocation = 'residentialLocation',
  IsHidden = 'isHidden',
  Scenarios = 'scenarios',
  DiversionTimeout = 'diversionTimeout',
  DiversionTimeoutEnabled = 'diversionTimeoutEnabled',
  Name = 'name',
  IsLocation = 'isLocation',
  Devices = 'devices',
  IntentionOutOfBedEnabled = 'intentionOutOfBedEnabled',
  AlternativeDiversionEnabled = 'alternativeDiversionEnabled',
  AlternativeDiversionOrganisationUnits = 'alternativeDiversionOrganisationUnits',
  EmergencyAlarmRoutesEnabled = 'emergencyAlarmRoutesEnabled',
  EmergencyAlarmRouteOrganisationUnits = 'emergencyAlarmRouteOrganisationUnits',
  ElectronicClientRecordRoom = 'electronicClientRecordRoom',
  TransmitterResidentSettings = 'transmitterResidentSettings',
}
